import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4106dfa3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-global-skeleton tw-flex tw-flex-row tw-justify-start" }
const _hoisted_2 = { class: "tw-py-[20px]" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-leading-[100%] tw-py-[20px] tw-pr-[25px] tw- w-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]" }, null, -1))

import { Ref, ref } from "vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
// eslint-disable-next-line no-unused-vars
const suggestion = 0;

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentQuestionSubCategorySkeleton',
  props: {
  /** The order number of sub question category */
  orderNumber: {
    type: Number,
    default: 1,
  },
  selectedQuestions: {
    type: Array as () => any[],
    default: () => [],
  },
  customClass: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;


const selectAll: Ref<boolean> = ref(false);
const showIcon: Ref<boolean> = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(`custom-global-skeleton tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#ffffff] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-border-[#EFF0F1] ${
        showIcon.value ? 'tw-rounded-[6px]' : 'tw-rounded-t-[6px]'
      }`)
    }, null, 2),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (item) => {
      return _createElementVNode("div", {
        key: item,
        class: _normalizeClass(`custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question ${__props.customClass}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`custom-global-skeleton tw-flex tw-flex-col tw-relative assessmentQuestion question ${__props.customClass}`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CustomCheckBox, {
                "is-checked": selectAll.value,
                "onUpdate:isChecked": _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                class: "tw-h-[20px] tw-ml-[25px] !tw-mb-0",
                size: "20px"
              }, null, 8, ["is-checked"])
            ]),
            _hoisted_3
          ])
        ], 2)
      ], 2)
    }), 64))
  ]))
}
}

})